import { Component } from '@angular/core';

@Component({
  selector: 'locker-access-icon',
  standalone: true,
  imports: [],
  templateUrl: './locker-access.component.html',
  styleUrls: ['./locker-access.component.scss'],
})
export class LockerAccessIcon {
}
